/* eslint-disable @typescript-eslint/no-unused-vars */

import { createContext, useContext } from 'react';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess as SEOSegmentationSearchResultsSuccessType } from '@/__generated__/getSearchResults';
import { SEOSegmentationFilterInput } from '@/__generated__/globalTypes';

export interface FiltersContext {
  filters: SEOSegmentationSearchResultsSuccessType['filters'];
  setFilters: (_filters: {}, _reset?: boolean) => void;
  fetchResults: (_filterVals: SEOSegmentationFilterInput, _resetPage: boolean) => void;
}

export const filtersCtx: FiltersContext = {
  filters: {
    __typename: 'SEOSegmentationFilters',
    location: {
      __typename: 'SEOLocationFilters',
      zipcode: '',
      city: '',
      state: null,
    },
  },
  setFilters: (_filters: {}, _reset?: boolean) => {},
  fetchResults: (_filterVals: SEOSegmentationFilterInput, _resetPage: boolean) => {},
};

export const SegmentationFiltersContext = createContext(filtersCtx);

export const useSegmentationFiltersContext = () => useContext(SegmentationFiltersContext);
